
const data = [
  {
    title: 'IT系统建设概述',
    description: 'IT系统建设重点强调IT与业务目标的配合；强调IT与企业的战略、管控模式和业务流程相匹配；强调分析行业发展趋势，并预见企业可能产生的变化。'
  },
  {
    title: '服务内容',
    description: '项目可研报告\n' +
      '建设方案\n' +
      '定制化开发与实施\n' +
      '知识转移'
  },
  {
    title: '服务特点',
    description: '深刻理解战略、组织、流程与IT技术的协调统一，把握IT服务的价值链，为企业提供从管理咨询、IT规划及应用系统集成与实施等全方位的服务。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/it-build.js